import { render, staticRenderFns } from "./ClearButtonRating.vue?vue&type=template&id=52c6fe16"
import script from "./ClearButtonRating.vue?vue&type=script&lang=js"
export * from "./ClearButtonRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports